export const ON_CLOCK_ANIMATION_DURATION = 0.5

export const DRAFT_TIME = {
  start: 1746571800,
  end: 1746667800,
}
export const DRAFT_BOARD_AUTHOR = {
  name: 'Adam Lamberti',
  profilePicture:
    'https://img.premierlacrosseleague.com/2025/thumbnail_Adam_Lamberti.webp',
}
